import { CountryCode } from "./language";

export type Feature = keyof typeof FEATURE_COUNTRIES;

/**
 * Maps features to the countries where they are enabled.
 * Add new features as keys and list the countries that support them.
 */
export const FEATURE_COUNTRIES = {
  contactPhone: [CountryCode.Danish],
} as const;

/**
 * Check if a feature is enabled for a given country.
 */
export const isFeatureEnabled = (
  feature: Feature,
  country: string
): boolean => {
  return FEATURE_COUNTRIES[feature].some((c) => c === country.toUpperCase());
};
